import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";

import { DbObjectCreateOrUpdateInfos } from "./db-object-create-or-update-infos";
import { DbAssetObjectInfos } from "./db-asset-object-infos";
import { CollectionType } from "./db-collection-type";
import { collectionKind } from "./db-collection-kind";
import { FileType } from "./db-collection-image-type";
import { CollectionLocation } from "./db-collection-location";

export class RelatedData extends DbMongoSerializationBaseInfos {
  date: Date | null = null;
  data: { $type: string; $value: string } | null = null;
  type: FileType | null = null;

  constructor(init?: Partial<RelatedData>) {
    super();
    Object.assign(this, init);
  }
}

export class DbObjectCollectionInfos extends DbMongoSerializationBaseInfos {
  platformId: number | null = 0;
  name: string | null = null;
  description: string | null = null;
  creationInfos: DbObjectCreateOrUpdateInfos | null = null;
  updateInfos: DbObjectCreateOrUpdateInfos[] | null = null;
  type: CollectionType | null = null;
  location?: CollectionLocation | null = null;
  isPublished?: boolean | null = false;
  kind?: collectionKind | null = null;
  targetGroupIds: number[] | null = null;
  targetUserIds: number[] | null = null;
  isSystem: boolean | null = false;
  objectIds: number[] | null = null;
  objectInfos: DbAssetObjectInfos[] | null = null;
  files: RelatedData[] | null = null;
  randomDisplay?: boolean | null = false;
  isShared?: boolean | null = false;

  constructor(init?: Partial<DbObjectCollectionInfos>) {
    super();
    Object.assign(this, init);
  }
}
